import React from 'react';
import Product from './Product.tsx';
import Topbar from './../layouts/topbar/Topbar.tsx';
import './Product.css';
import TopHeader from '../../components/TopHeader.tsx';

const index = () => {
  return (
    <div>
      {/* <TopHeader /> */}
      <Topbar />
    </div>
  );
};

export default index;
